'use client';

import Image from 'next/image';
import { cn } from '@/lib/utils';
import SectionHeading from '@/components/layout/section-heading';

const covers = [
    { src: '/covers/Book-Cover-1.jpg', alt: 'Cover 1' },
    { src: '/covers/Book-Cover-2.jpg', alt: 'Cover 2' },
    { src: '/covers/Book-Cover-2.png', alt: 'Cover 3' },
    { src: '/covers/Book-Cover-5.jpg', alt: 'Cover 4' },
    { src: '/covers/Book-Cover-6.jpg', alt: 'Cover 6' },
    { src: '/covers/Book-Cover-7.jpg', alt: 'Cover 7' },
    { src: '/covers/Book-Cover-9.jpg', alt: 'Cover 9' },
    { src: '/covers/Book-Cover-10.jpg', alt: 'Cover 10' },
    { src: '/covers/Book-Cover-11.jpg', alt: 'Cover 11' },
    { src: '/covers/Book-Cover-12.jpg', alt: 'Cover 12' },
    { src: '/covers/Book-Cover-13.jpg', alt: 'Cover 13' },
    { src: '/covers/Book-Cover-16.jpg', alt: 'Cover 16' },
];

function CoverCard({ item }) {
    return (
        <div
            className="
        group relative w-[180px] sm:w-[220px] md:w-[280px]
        overflow-hidden rounded-none
        bg-muted/30 ring-1 ring-border/60
        transition hover:shadow-lg hover:-translate-y-1
      "
        >
            <div className="relative aspect-7/10 w-full">
                <Image src={item.src} alt={item.alt} fill className="object-cover" sizes="220px" />
            </div>

            {/* subtle shine */}
            <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <div className="absolute -left-1/2 top-0 h-full w-1/2 rotate-12 bg-linear-to-r from-transparent via-white/20 to-transparent" />
            </div>
        </div>
    );
}

function MarqueeRow({ items, direction = 'left', speed = 30 }) {
    // Duplicate items for seamless loop
    const loopItems = [...items, ...items];

    return (
        <div className="relative overflow-hidden">
            <div
                className={cn(
                    'flex w-max gap-5 py-2',
                    direction === 'left' ? 'animate-marquee-left' : 'animate-marquee-right'
                )}
                style={{
                    animationDuration: `${speed}s`,
                }}
            >
                {loopItems.map((item, i) => (
                    <CoverCard key={item.src + i} item={item} />
                ))}
            </div>
        </div>
    );
}

export default function BookCoversMarquee({
    className,
    items = covers,
    isSectionInfo = true,
    slideRow1 = true,
    slideRow2 = true,
}) {
    const half = Math.ceil(items.length / 2);
    const row1 = items.slice(0, half);
    const row2 = items.slice(half);

    return (
        <section className={cn('', className)}>
            {isSectionInfo && (
                <div className="container px-4 sm:px-6 lg:px-8">
                    <SectionHeading
                        align="center"
                        title={
                            <>
                                Books We’ve <span>Published</span>
                            </>
                        }
                        //                        description="Take a look at books created using our comprehensive self-publishing services for new and experienced authors. We prepare and distribute titles across Amazon, Barnes & Noble, Kobo, and other top publishing platforms."
                    />
                </div>
            )}

            {/* Slider */}
            <div className="mt-10 space-y-6">
                {/* Fade edges */}
                {slideRow1 && (
                    <div className="relative">
                        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent z-10" />
                        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent z-10" />

                        <MarqueeRow items={row1} direction="left" speed={28} />
                    </div>
                )}
                {slideRow2 && (
                    <div className="relative">
                        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent z-10" />
                        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent z-10" />

                        <MarqueeRow items={row2} direction="right" speed={32} />
                    </div>
                )}
            </div>
        </section>
    );
}
